import "./Level4.scss";

export default function Level4() {
  return (
    <div className="level4__container">
      <div className="level4__puzzle">
        <div className="level4__file">
          <p className="level4__letter">A</p>
          <img
            className="level4__clue"
            alt="Emoji smiling face with smiling eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558104/smiling-face-with-smiling-eyes_1f60a_gl8iob.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">B</p>
          <img
            className="level4__clue"
            alt="Emoji grinning face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558356/grinning-face_1f600_ltlmv2.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">C</p>
          <img
            className="level4__clue"
            alt="Emoji grinning face with big eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558356/grinning-face-with-big-eyes_1f603_ya2m3z.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">D</p>
          <img
            className="level4__clue"
            alt="Emoji grinning face with smiling eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558356/grinning-face-with-smiling-eyes_1f604_bsktgu.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">E</p>
          <img
            className="level4__clue"
            alt="Emoji beaming face with smiling eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558357/beaming-face-with-smiling-eyes_1f601_lghvon.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">F</p>
          <img
            className="level4__clue"
            alt="Emoji grinning squinting face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558568/grinning-squinting-face_1f606_x4tyo8.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">G</p>
          <img
            className="level4__clue"
            alt="Emoji grinning face with sweat"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558879/grinning-face-with-sweat_1f605_b8lf3e.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">H</p>
          <img
            className="level4__clue"
            alt="Emoji slightly smiling face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558728/slightly-smiling-face_1f642_mzbcxz.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">I</p>
          <img
            className="level4__clue"
            alt="Emoji relieved face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558726/relieved-face_1f60c_xk2jsp.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">J</p>
          <img
            className="level4__clue"
            alt="Emoji slightly smiling face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710561272/kissing-face_1f617_pgzxse.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">K</p>
          <img
            className="level4__clue"
            alt="Emoji kissing face with smiling eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559478/kissing-face-with-smiling-eyes_1f619_qdgldd.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">L</p>
          <img
            className="level4__clue"
            alt="Emoji slightly frowning face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559478/slightly-frowning-face_1f641_qxulid.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">M</p>
          <img
            className="level4__clue"
            alt="Emoji confused face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559480/confused-face_1f615_zcb2oa.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">N</p>
          <img
            className="level4__clue"
            alt="Emoji face with open mouth"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559481/face-with-open-mouth_1f62e_ivkgkc.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">O</p>
          <img
            className="level4__clue"
            alt="Emoji hushed face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710560993/hushed-face_1f62f_q9mmhh.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">P</p>
          <img
            className="level4__clue"
            alt="Emoji woozy face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710560201/woozy-face_1f974_rljcji.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">Q</p>
          <img
            className="level4__clue"
            alt="Emoji anguished face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559709/astonished-face_1f632_tjr8za.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">R</p>
          <img
            className="level4__clue"
            alt="Emoji sad but relieved face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559975/sad-but-relieved-face_1f625_fhfvmo.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">S</p>
          <img
            className="level4__clue"
            alt="Emoji crying face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559977/crying-face_1f622_esunyz.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">T</p>
          <img
            className="level4__clue"
            alt="Emoji weary face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559979/weary-face_1f629_ok0rpy.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">U</p>
          <img
            className="level4__clue"
            alt="Emoji tired face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710561179/tired-face_1f62b_udcgua.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">V</p>
          <img
            className="level4__clue"
            alt="Emoji pouting face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710560203/pouting-face_1f621_w5yuvg.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">W</p>
          <img
            className="level4__clue"
            alt="Emoji angry face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710560207/angry-face_1f620_llowus.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">X</p>
          <img
            className="level4__clue"
            alt="Emoji neutral face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710560205/neutral-face_1f610_dmpghs.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">Y</p>
          <img
            className="level4__clue"
            alt="Emoji face with medical mask"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710560458/face-with-medical-mask_1f637_b2wwlq.png"
          />
        </div>
        <div className="level4__file">
          <p className="level4__letter">Z</p>
          <img
            className="level4__clue"
            alt="Emoji expressionless face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710560460/expressionless-face_1f611_napxyh.png"
          />
        </div>
      </div>

      <div className="level4__guess-container">
        <span className="level4__guess">
          <img
            alt="Emoji relieved face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558726/relieved-face_1f60c_xk2jsp.png"
          />
          <img
            alt="Emoji grinning face with smiling eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558356/grinning-face-with-smiling-eyes_1f604_bsktgu.png"
          />
          <img
            alt="Emoji beaming face with smiling eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558357/beaming-face-with-smiling-eyes_1f601_lghvon.png"
          />
          <img
            alt="Emoji hushed face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710560993/hushed-face_1f62f_q9mmhh.png"
          />
          <img
            alt="Emoji grinning face with sweat"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558879/grinning-face-with-sweat_1f605_b8lf3e.png"
          />
          <img
            alt="Emoji sad but relieved face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559975/sad-but-relieved-face_1f625_fhfvmo.png"
          />
          <img
            alt="Emoji smiling face with smiling eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558104/smiling-face-with-smiling-eyes_1f60a_gl8iob.png"
          />
          <img
            alt="Emoji confused face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559480/confused-face_1f615_zcb2oa.png"
          />
          <img
            alt="Emoji smiling face with smiling eyes"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710558104/smiling-face-with-smiling-eyes_1f60a_gl8iob.png"
          />
          <img
            alt="Emoji crying face"
            src="https://res.cloudinary.com/df7zuvuxu/image/upload/v1710559977/crying-face_1f622_esunyz.png"
          />
        </span>
      </div>
    </div>
  );
}
